import React from 'react';
import { View } from 'react-native';
import RadioButton from './RadioButton';
import { LocStr } from '../../../utils/Utils';
import { textPrimary_20_9 } from '../../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================

const RadioPanelRecipient = ({
  valueLeft,
  valueMiddle,
  valueRight,
  headlineLeftOption,
  headlineMiddleOption,
  headlineRightOption,
  onPressLeftOption,
  onPressMiddleOption,
  onPressRightOption,
  language,
  title,
}) => (
  <View>
    {title
    && <textPrimary_20_9 style={{ fontWeight: 'bold', marginBottom: 8 }}>{title}</textPrimary_20_9>}
    <View style={{
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: 20,
    }}
    >
      <RadioButton
        text={LocStr(headlineLeftOption, language)}
        isSelected={valueLeft}
        onPress={onPressLeftOption}
        threeInARow
      />
      <RadioButton
        text={LocStr(headlineMiddleOption, language)}
        isSelected={valueMiddle}
        onPress={onPressMiddleOption}
        threeInARow
      />
      <RadioButton
        text={LocStr(headlineRightOption, language)}
        isSelected={valueRight}
        onPress={onPressRightOption}
      />
    </View>
  </View>
);
export default RadioPanelRecipient;
